import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AccordionContextProvider } from '../../../contexts';

const ICON = {
  CHEVRON: 'chevron',
  PLUS: 'plus',
};

const Accordion = ({
  activeKey,
  onChange,
  children,
  className,
  type,
  icon,
}) => {
  const adClass = classNames({
    [className]: className,
    'accordion-plus': icon === ICON.PLUS,
  });

  return 'normal' === type ? (
    <AccordionContextProvider
      activeKey={activeKey}
      onChange={onChange}
    >
      <div className={`accordion  ${adClass}`}>{children}</div>
    </AccordionContextProvider>
  ) : 'checkout' === type ? (
    <AccordionContextProvider
      activeKey={activeKey}
      onChange={onChange}
    >
      <div className="accordion-summary">{children}</div>
    </AccordionContextProvider>
  ) : (
    ''
  );
};

Accordion.propTypes = {
  activeKey: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node.isRequired,
  adClass: PropTypes.string,
  type: PropTypes.oneOf(['normal', 'checkout']),
  icon: PropTypes.oneOf(Object.values(ICON)),
  className: PropTypes.string,
};

Accordion.defaultProps = {
  activeKey: null,
  onChange: () => {},
  type: 'normal',
  icon: ICON.CHEVRON,
};

export default Accordion;
